import { render, staticRenderFns } from "./ImageCaptcha.vue?vue&type=template&id=5748cb34&"
import script from "./ImageCaptcha.vue?vue&type=script&lang=js&"
export * from "./ImageCaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports